
import { useEffect, useState } from "react";
import User from "../../../../assets/icons/User";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import {
	ProfileOutlineLink,
	ProfileSection,
	ProfileSectionError,
	profileFieldText,
} from "../common/ProfileSection";

export default function InfoSection({ profileId, isOwner, onFetchName }) {
	const [profile, setProfile] = useState({});
	const [errorMessage, setErrorMessage] = useState("");

	useEffect(() => {
		fetchProfile();
	}, []);

	function fetchProfile() {
		api.profileDetail({
			token: LoginHelper.getToken(),
			profile_id: profileId,
		})
			.then((result) => {
				setProfile(result);
				if (onFetchName) {
					const name = profileFieldText(result?.name) || result?.name || "";
					onFetchName(name);
				}
			})
			.catch((err) => {
				if (err && err.data) {
					setErrorMessage(err.data.message);
				}
			});
	}

	const displayName = profileFieldText(profile.name) || profile.name || "—";

	return (
		<ProfileSection>
			<div className="flex flex-col items-center text-center gap-3">
				{profile.avatar_url ? (
					<img
						src={profile.avatar_url}
						alt=""
						className="w-[96px] h-[96px] rounded-full object-cover ring-2 ring-lightCta ring-offset-2"
					/>
				) : (
					<span className="flex h-[96px] w-[96px] items-center justify-center rounded-full bg-lightCta ring-2 ring-[#E2E8F0] ring-offset-2">
						<User width={40} height={40} />
					</span>
				)}
				<h1 className="font-Vazir-700 text-[18px] text-darkBlue">{displayName}</h1>
				{isOwner ? (
					<div className="flex flex-col items-center gap-3 w-full max-w-[280px]">
						<ProfileOutlineLink to="/profile_edit/" className="w-full">
							ویرایش پروفایل
						</ProfileOutlineLink>
						<p className="font-Vazir-400 text-[13px] text-grayText">
							آیا درمانگر هستید؟
						</p>
						<ProfileOutlineLink to="/profile_edit_doctor/" className="w-full">
							ویرایش اطلاعات درمانگر
						</ProfileOutlineLink>
					</div>
				) : null}
				<ProfileSectionError message={errorMessage} />
			</div>
		</ProfileSection>
	);
}
